import { render, staticRenderFns } from "./OptionPropertyAuthorityYN.vue?vue&type=template&id=4748c4b2"
import script from "./OptionPropertyAuthorityYN.vue?vue&type=script&lang=js"
export * from "./OptionPropertyAuthorityYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports